/* eslint-disable @angular-eslint/directive-selector */
import { Directive, Input, NgModule } from '@angular/core';
import { PathRouter } from './model/typed-router.model';

@Directive({
  selector: '[routerLink]',
})
export class ElioElioTypedRouterLinkedDirective {
  @Input() routerLink!: PathRouter[];
}

@NgModule({
  declarations: [ElioElioTypedRouterLinkedDirective],
  exports: [ElioElioTypedRouterLinkedDirective],
})
export class ElioElioTypedRouterLinkedDirectiveModule {}
